module.exports = __webpack_public_path__ + "static/media/about-us-3.61d044fd.jpg";